import store from "@src/reducers/store";
import { updateUserManagementListActiveView } from "@src/reducers/your-reducer";
import { UserManagementListActiveViewType } from "@src/types/user-management";

export interface UseUserManagementListPillsNavHookProps {
  updateUserManagementListActiveViewHandler: (
    activeView: UserManagementListActiveViewType,
  ) => void;
}

export const useUserManagementListPillsNav =
  (): UseUserManagementListPillsNavHookProps => {
    const updateUserManagementListActiveViewHandler = (
      activeView: UserManagementListActiveViewType,
    ) => {
      store.dispatch(updateUserManagementListActiveView(activeView));
    };
    return { updateUserManagementListActiveViewHandler };
  };
